/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

<template>
  <div class="product-price">
    <div v-if="productPrice.giftCard.amounts && productPrice.giftCard.amounts.length">
      <div class="gift-prices">
        <div v-for="(amount, index) in productPrice.giftCard.amounts" :key="index">
          <span class="amount">{{ amount | price($store) }}</span>
        </div>
      </div>
    </div>
    <div v-else class="has-product-discount">
      <template v-if="productPrice.discount.percent_off !== 0">
        <span class="price-value product-price_current"> {{productPrice.currentPrice}}</span>
        <span class="price-value product-price_original discount">{{productPrice.regularPrice}}</span>
        <span class="price-value product-price_discount">-{{productPrice.discount.percent_off}}%</span>
      </template>
      <template v-else>
        <span class="price-value f-md">{{productPrice.startingFromPrice ? productPrice.startingFromPrice : productPrice.currentPrice}}</span>
        <div v-if="productPrice.regularPrice !== null">
          <span class="price-value">{{productPrice.regularPrice}}</span>
        </div>
      </template>
    </div>
    <div v-if="productPrice.tierPriceOnQantity.length">
      <template v-for="(tier, index) in productPrice.tierPriceOnQantity">
        <div :key="index" v-html="tier"></div>
      </template>
    </div>
  </div>
</template>

<script>
import { getRangePriceFromProduct, getMinimumPriceProducts } from '@/helpers/utils'
import { price as filterPrice } from '@/filters'

export default {
  props: {
    product: {
      type: Object | Array,
      required: true
    }
  },
  computed: {
    productPrice () {
      const _this = this
      let priceObj = {
        currentPrice: null,
        currentPriceValue: 0,
        regularPrice: null,
        startingFromPrice: null,
        giftCard: {
          amounts: []
        },
        tierPriceOnQantity: [],
        discount: {
          amount_off: 0,
          percent_off: 0
        }
      }
      let product = this.product
      if (product && product.length > 0) {
        product = getMinimumPriceProducts(product)
      }
      let rangePrice = getRangePriceFromProduct(product)
      // on first load, price is minimum_price.final_price
      // when variant is selected price is from minimum_price.final_price and maximum_price.regular_price is showed
      //    ex -> now 33 / regular price 100
      // tier price -> graphql return array of tiers config the first element is used to display price
      // if tier quantity is > 1 tiers price is showed under current price.
      //    ex (Bag price is 30€) (Tiers quantity is 10 at 20€)
      //    ex price 30€ and a new message is shown -> buy 10 (quantity) at 20€ (price)
      if (product.special_price) {
        priceObj.currentPrice = filterPrice(product.special_price, _this.$store)
        priceObj.currentPriceValue = parseFloat(product.special_price)
      } else if (rangePrice.min.regular_price.value === rangePrice.max.regular_price.value) {
        priceObj.currentPrice = filterPrice(rangePrice.min.final_price.value, _this.$store)
        priceObj.currentPriceValue = parseFloat(rangePrice.min.final_price.value)
      } else {
        // has price range
        priceObj.currentPrice = this.$t('from {price}', { price: filterPrice(rangePrice.min.final_price.value, _this.$store) })
        priceObj.currentPriceValue = parseFloat(rangePrice.min.final_price.value)
      }
      // If final price not math with regular price
      // show old price below final price
      if (rangePrice.min.final_price.value !== rangePrice.min.regular_price.value) {
        // priceObj.regularPrice = this.$t('Regular Price {price}', { price: filterPrice(rangePrice.max.regular_price.value) })
        priceObj.regularPrice = filterPrice(rangePrice.max.regular_price.value, _this.$store)
        priceObj.discount = rangePrice.min.discount
      }
      // if product has a tiers show this price by quantity
      if (product.price_tiers && product.price_tiers.length) {
        product.price_tiers.forEach(tier => {
          let tierPriceFinal = filterPrice(tier.final_price.value, _this.$store)
          if (tier.quantity > 1) {
            // priceObj.tierPriceOnQantity.push('Buy ' + tier.quantity + ' at ' + tierPriceFinal)
            priceObj.tierPriceOnQantity.push(this.$t('Buy {quantity} at {price}', { quantity: tier.quantity, price: tierPriceFinal }))
          } else {
            priceObj.tierPriceOnQantity.push(this.$t('For you at {price}', { price: tierPriceFinal }))
          }
        })
      }
      if (priceObj.discount.percent_off !== 0) {
        priceObj.discount.percent_off = Math.round(priceObj.discount.percent_off)
      }
      // add gift card amount
      if (product.aw_gc_amounts) {
        priceObj.giftCard.amounts = product.aw_gc_amounts
      }

      if (product.hasOwnProperty('true_price_range') && !product.isVariant && product.price_range.minimum_price.discount.amount_off === 0 && product.true_price_range.min !== product.true_price_range.max) {
        priceObj.currentPrice = filterPrice(product.true_price_range.min, _this.$store)
        priceObj.currentPriceValue = parseFloat(product.true_price_range.min)
        priceObj.startingFromPrice = 'A partire da ' + priceObj.currentPrice.toString()
      }

      return priceObj
    }
  }
}
</script>
